import React, { Component } from "react";
import { Menu, Spin } from "antd";
import PropTypes from "prop-types";
import {
  SettingOutlined,
  ToolOutlined,
  LineChartOutlined,
  WarningOutlined,
  FileTextOutlined,
  DesktopOutlined,
  FileSearchOutlined,
  PieChartOutlined,
  BarChartOutlined,
  ReconciliationOutlined,
  HomeOutlined,
  BankOutlined,
} from "@ant-design/icons";
import { initPanels } from "../../../state/action/comAction";

const SubMenu = Menu.SubMenu;

/*
 *  数据菜单组件
 *  @class StarMenu
 *  @property openMenuArr {Array} 已展开的菜单数组
 *  @property rootSubmenuKeys {Array} 父菜单的key值数组
 *  @state menuList {Object} 用户构建菜单渲染的数据对象
 *  @state defaultSelectedkeys 默认选择的菜单key
 * */

class StarMenu extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
  };

  constructor(props) {
    super();
    this.props = props;
    this.rootSubmenuKeys = [];
    this.openMenuArr = [];
    this.state = {
      menuList: null,
      defaultselectedkeys: [],
    };
  }

  componentWillMount() {
    this.getUserMenuList();
    window.refreshMenu = this.getUserMenuList.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.clearOpenKey !== this.props.clearOpenKey && nextProps.clearOpenKey) {
      this.setState({
        openkeys: [],
      });
    }
  }

  // 获取菜单列表数据
  getUserMenuList() {
    // 通过fetchHandler公共函数来处理接口数据，成功请求则返回包含数据和对应code的对象，否则通过message进行提示。
    let data = window.sessionStorage.getItem("menulist");
    if (!data) {
      this.context.router.history.push("login");
      return;
    }

    let menu = [];
    if (data) {
      data = JSON.parse(data);
      if (data.length === 0) {
        this.context.router.history.push("nomenu");
        return;
      }
      // 转换数据
      menu = transformMenudata(data);
      this.setState({ menuList: menu }, () => {
        this.getDefaultPage(menu[0]);
      });
    }

    if (!menu || menu.length === 0) {
      this.context.router.history.push("nomenu");
    }
  }

  // 返回默认首页

  getDefaultPage(page) {
    if (page) {
      if (page.childList) {
        const p = page.childList[0];
        this.openMenuArr.push(page.id);
        this.getDefaultPage(p);
      } else {
        // 设置默认初始tab
        const tab = [
          { title: page.title, content: this.props.Frame[page.id], key: page.id, closable: true },
        ];
        const pageId = page.id;
        this.openMenuArr.push(page.id);
        this.setState({
          selectedkeys: [page.id],
          defaultopenkeys: this.openMenuArr,
          openkeys: this.openMenuArr,
        });
        this.props.addTab({ key: page.id });
        // 更新Panels数组状态
        this.context.store.dispatch(initPanels("project", tab, pageId));
      }
    }
  }

  // 根据数据构建菜单
  generateMenu(menuArr) {
    const menuDom = [];
    if (menuArr) {
      for (const m of menuArr) {
        let icon;
          switch (m.icon) {
            case "HomeOutlined":
              icon = <HomeOutlined />;
              break;
            case "SettingOutlined":
              icon = <SettingOutlined />;
              break;
            case "ToolOutlined":
              icon = <ToolOutlined />;
              break;
            case "LineChartOutlined":
              icon = <LineChartOutlined />;
              break;
              case "WarningOutlined":
                icon = <WarningOutlined />;
                break;
              case "FileTextOutlined":
                icon = <FileTextOutlined />;
                break;
              case "DesktopOutlined":
                icon = <DesktopOutlined />;
                break;
              case "FileSearchOutlined":
                icon = <FileSearchOutlined />;
                break;
              case "PieChartOutlined":
                icon = <PieChartOutlined />;
                break;
              case "BarChartOutlined":
                icon = <BarChartOutlined />;
                break;
              case "ReconciliationOutlin":
                icon = <ReconciliationOutlined />;
                break;
              case "BankOutlined":
                  icon = <BankOutlined />;
                  break;
            default:
                break;
          }
        if (m.childList === null) {
          menuDom.push(
            <Menu.Item key={m.id} uri={m.uri} icon={m.id === "02" ? icon : null}>
              <span uri={m.uri}>{m.title}</span>
            </Menu.Item>,
          );
        } else {
          this.rootSubmenuKeys.push(m.id);
          menuDom.push(
            <SubMenu
              key={m.id}
              icon={m.id !== "0301" ? icon : null}
              title={
                <span>
                  <span>{m.title}</span>
                </span>
              }>
              {this.generateMenu(m.childList)}
            </SubMenu>,
          );
        }
      }
      return menuDom;
    }
  }

  // 打开子菜单关闭父菜单及兄弟菜单
  onOpenChange = (openKeys) => {
    const latestOpenKey = openKeys.find((key) => this.state.openkeys.indexOf(key) === -1);
    const latestLen = latestOpenKey ? latestOpenKey.length : 0;
    const latestOpenKeyArr = [];
    for (let i = 0; i < latestLen; i += 2) {
      latestOpenKeyArr.push(latestOpenKey.substr(0, latestLen - i));
    }
    if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      this.setState({ openkeys: openKeys });
    } else {
      this.setState({
        openkeys: latestOpenKey ? latestOpenKeyArr : [],
      });
    }
  };

  render() {
    return (
      <div>
        {this.state.defaultopenkeys &&
        (this.state.menuList.map((v) => v.id).includes("02")
          ? true
          : this.state.defaultopenkeys[0]) ? (
          <Menu
            className="ant-scroll-menu"
            theme="dark"
            mode={this.props.collapsed ? "vertical" : "inline"}
            defaultSelectedKeys={this.state.selectedkeys}
            openKeys={this.state.openkeys}
            onOpenChange={this.onOpenChange}
            onClick={this.props.addTab}>
            {this.generateMenu(this.state.menuList)}
          </Menu>
        ) : null}
        {!this.state.menuList && <Spin />}
      </div>
    );
  }
}

export default StarMenu;

StarMenu.propsType = {
  addTab: PropTypes.func.isRequired,
  Frame: PropTypes.object.isRequired,
};

function transformMenudata(input) {
  if (input && Array.isArray(input) && input.length > 0) {
    return input.map((item) => {
      return {
        id: item.ctMenuId,
        uri: null,
        title: item.cname,
        icon: item.icon,
        childList: transformMenudata(item.childList),
      };
    });
  } else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/AntD/components/display/menu/menu.js